import { PlaybackTypes } from 'models/kitchenSink';
import { VideoLike as Video } from 'store-types';

export const getVideoType = (video: Video | null | undefined): string | undefined => video?.properties?.type;

export const isLiveVideo = (video: Video | null | undefined): boolean => {
  const type = getVideoType(video);
  return type === 'live-linear' || type === 'live';
};

export const isLiveLinear = (video: Video | null | undefined): boolean => {
  const type = getVideoType(video);
  return type === 'live-linear';
};

export const isPreGame = (video: Video | null | undefined): boolean => video?.event?.status === 'pre';

export const isVodContent = (video: Video | null | undefined): boolean => {
  const type = getVideoType(video);
  return type === 'vod';
};

export const isUpcoming = (video: Video | null | undefined): boolean => {
  // Enforce start date to handle real time transitions better
  return video
    ? video.event?.status === 'upcoming' &&
        (video.schedule?.videoStartDate as number) * 1000 > Date.now()
    : false;
};

export const shouldUseDASH = (video: Video): boolean => {
  return video.playback?.type === PlaybackTypes.FULL_DRM;
};
